<template>
  <div class="historyWith">
    <van-steps
      direction="vertical"
      active="100"
      active-icon=""
      active-color="#969799"
    >
      <van-step v-for="(item, index) in form" :key="index">
        <div class="withTitle">
          {{item.name}} <span class="withTime">{{item.time}}</span>
        </div>
        <div>{{item.msg}}</div>
      </van-step>
    </van-steps>
  </div>
</template>
<script>
import { request } from "../mixins/request";
import { getRefundLog } from "../api/index";
export default {
  data() {
    return {
      form: [
        {
          name: "邓志远",
          time: "1970-01-01 08:00:00",
          msg: "卖家退货。物流公司：顺丰速运，物流单号：121221，快递方式：快递。",
        },
        {
          name: "商家",
          time: "1970-01-01 08:00:00",
          msg: "商家确认收货地址：张鹏飞，15664055075，河南省郑州市荥阳崔庙镇百爱云集健康产业园。",
        },
        {
          name: "商家",
          time: "1970-01-01 08:00:00",
          msg: "商家同意了本次售后服务申请。",
        },
        {
          name: "邓志远",
          time: "2021-07-28 14:25:30",
          msg: "发起了退货退款申请，货物状态：已收到货，退款原因：不想要，退款金额：18.00元。",
        },
      ],
      order_refund_id: "",
    };
  },
  mixins: [request],
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const data = await getRefundLog({
        order_refund_id: this.order_refund_id,
      });
      console.log(data);
    },
  },
};
</script>
<style scoped>
.historyWith {
  padding-top: 1.5rem;
  padding-left: 1rem;
}
.historyWith .van-steps {
  background-color: rgba(0, 0, 0, 0);
}
.historyWith .withStatus {
  font-size: 0.875rem;
  color: #6b6b6b;
}
.historyWith .withTitle {
  font-size: 0.94rem;
  color: #333333;
}
.historyWith .withTime {
  font-size: 0.75rem;
  color: #828282;
}
</style>